import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  BrandModel,
  BrandResourceService,
  BrandTitleModel,
  ObjectUploadResponse,
  PagedBrandModel,
  PagedBrandTitleModel,
  SaveBrandRequest,
  SaveBrandTitleRequest,
  SaveResult,
} from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxBrandService {
  constructor(
    private brandResourceService: BrandResourceService,
  ) {
  }

  getBrands(params?: {
    page?: number,
    limit?: number,
    query?: string
  }): Promise<PagedBrandModel> {
    return firstValueFrom(this.brandResourceService.getBrands(params?.limit, params?.page, params?.query));
  }

  getBrandById(id: number): Promise<BrandModel> {
    return firstValueFrom(this.brandResourceService.getBrandById(id));
  }

  getMyBrands(): Promise<BrandModel[]> {
    return firstValueFrom(this.brandResourceService.getMyBrands());
  }

  removeBrand(id: number): Promise<any> {
    return firstValueFrom(this.brandResourceService.removeBrandById(id));
  }

  saveBrand(req: SaveBrandRequest): Promise<SaveResult> {
    return firstValueFrom(this.brandResourceService.saveBrand(req));
  }

  getBrandTitles(params?: {
    brandId?: number;
    page?: number;
    limit?: number;
    query?: string;
  }): Promise<PagedBrandTitleModel> {
    return firstValueFrom(this.brandResourceService.getBrandTitles(params?.brandId, params?.limit, params?.page, params?.query));
  }

  getBrandTitleById(id: number): Promise<BrandTitleModel> {
    return firstValueFrom(this.brandResourceService.getBrandTitleById(id));
  }

  removeBrandTitle(id: number): Promise<any> {
    return firstValueFrom(this.brandResourceService.removeBrandTitleById(id));
  }

  saveBrandTitle(req: SaveBrandTitleRequest): Promise<SaveResult> {
    return firstValueFrom(this.brandResourceService.saveBrandTitle(req));
  }

  getFileUploadUrl(id: number): string {
    return `/api/vn/brands/titles/${id}/files`;
  }

  removeFile(id: number, fileName: string): Promise<any> {
    return firstValueFrom(this.brandResourceService.deleteFile(id, fileName));
  }

  getBrandImageUrls(id: number): Promise<ObjectUploadResponse[]> {
    return firstValueFrom(this.brandResourceService.getBrandFiles(id));
  }
}
